export enum PriceText {
    NotSpecified = 'Keine Angaben',
    HighPrice = 'Hoher Preis',
    IncreasedPrice = 'Erhöhter Preis',
    FairPrice = 'Fairer Preis',
    GoodPrice = 'Guter Preis',
    VeryGoodPrice = 'Sehr guter Preis',
}
